/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable class-methods-use-this */
import { Controller } from "@hotwired/stimulus";

const MOBILE_LIMIT_SIZE = 768;
const AVAILABLE_TARGETS = Array(20)
  .fill(0)
  .map((item, index) => `element${index}`);

export default class extends Controller {
  static targets = AVAILABLE_TARGETS;

  connect() {
    this.availableTargets = this.getAvailableTargets();

    this.onWindowChange(window);
    window.addEventListener("resize", this.onWindowChange.bind(this));
  }

  disconnect() {
    window.removeEventListener("resize", this.onWindowChange.bind(this));
  }

  onWindowChange(e) {
    const isMobile = (e.innerWidth || e.target.innerWidth) < MOBILE_LIMIT_SIZE;

    this.resetLayouts();

    if (!isMobile) {
      this.checkLayouts();
    }
  }

  getAvailableTargets() {
    const availableTargets = [];

    AVAILABLE_TARGETS.forEach((target) => {
      if (this[`${target}Targets`].length > 1) {
        availableTargets.push(this[`${target}Targets`]);
      }
    });

    return availableTargets;
  }

  handleTargets(callback = () => {}) {
    this.availableTargets.forEach((target) => callback(target));
  }

  checkLayouts() {
    this.handleTargets((data) => this.setMaxHeight(data));
  }

  resetLayouts() {
    this.handleTargets((data) => data.forEach((item) => (item.style.height = "auto")));
  }

  setMaxHeight(elements) {
    const maxValue = Math.max(...elements.map((element) => element.offsetHeight));
    elements.forEach((element) => (element.style.height = `${maxValue}px`));
  }
}
